import { useReducer } from "react";

import { CartContext } from "./CartContext";
import { IRecord, RecordState } from "../interfaces/interfaces";
import { CartReducer } from "./CartReducer";

const INITIAL_STATE: RecordState = {
  records: [],
  deletedRecords: [],
  editForm: {
    _id: "",
    name: "",
    email: "",
    phone: "",
    date: "",
  },
};

interface props {
  children: JSX.Element | JSX.Element[];
}

export const CartProvider = ({ children }: props) => {
  const [recordState, dispatch] = useReducer(CartReducer, INITIAL_STATE);

  const getRecords = (records: IRecord[]) => {
    dispatch({ type: "getRecords", payload: records });
  };
  const getDeletedRecords = (records: IRecord[]) => {
    dispatch({ type: "getDeletedRecords", payload: records });
  };
  const addRecord = (record: IRecord) => {
    dispatch({ type: "addRecord", payload: record });
  };
  const addDeletedRecord = (record: IRecord) => {
    dispatch({ type: "addDeletedRecord", payload: record });
  };
  const editRecord = (record: IRecord) => {
    dispatch({ type: "editRecord", payload: record });
  };
  const addEditForm = (record: IRecord) => {
    dispatch({ type: "addEditForm", payload: record });
  };
  const deleteRecord = (record: IRecord) => {
    dispatch({ type: "deleteRecord", payload: record });
  };
  const restoreRecord = (record: IRecord) => {
    dispatch({ type: "restoreRecord", payload: record });
  };

  return (
    <CartContext.Provider
      value={{
        recordState,
        getRecords,
        getDeletedRecords,
        addRecord,
        addDeletedRecord,
        editRecord,
        addEditForm,
        deleteRecord,
        restoreRecord,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
